import { createSlice } from '@reduxjs/toolkit';

import { getInventoryDetails, updateInventoryDetails, downloadSampleInventoryFile, uploadInventoryFile, updatedelistedDetails, toggleVendorInventorySwitch } from '../../apis';

export const getVendorInventoryDetails = createSlice({
    name: 'shippingItems',
    initialState: {
        isLoading: false,
        data : [],
        error: '',
        updateInventorySuccess: false,
        downloadSampleInventoryFileSuccess: false,
        uploadInventoryFileSuccess: false,
        updatedelistedDetailsSuccess: false,
        toggleVendorInventorySwitchSuccessMessage: '',
    },

    reducers: {
        clearErrorState: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clearUpdateInventorySuccess: (state, action) => {
            return {
                ...state,
                updateInventorySuccess: action.payload
            }
        },
        clearDownloadSampleInventoryFileSuccess: (state, action) => {
            return {
                ...state,
                downloadSampleInventoryFileSuccess: action.payload
            }
        },
        clearUploadInventoryFileSuccess: (state, action) => {
            return {
                ...state,
                uploadInventoryFileSuccess: action.payload
            }
        },
        ClearUpdatedelistedDetailsSuccess: (state, action) => {
            return {
                ...state,
                updatedelistedDetailsSuccess: action.payload
            }
        },
        clear: (state, action) => {
            if (action.payload.key) {
                return {
                    ...state,
                    [action.payload.key]: action.payload.value
                }
            }
            return {...state}
        }
    },

    extraReducers: (builder) => {
        builder.addCase(getInventoryDetails.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(getInventoryDetails.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.data = action.payload.data
        })
        builder.addCase(getInventoryDetails.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(updateInventoryDetails.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(updateInventoryDetails.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.updateInventorySuccess = true;
        })
        builder.addCase(updateInventoryDetails.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(downloadSampleInventoryFile.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(downloadSampleInventoryFile.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.downloadSampleInventoryFileSuccess = true;
        })
        builder.addCase(downloadSampleInventoryFile.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(uploadInventoryFile.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(uploadInventoryFile.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.uploadInventoryFileSuccess = true;
        })
        builder.addCase(uploadInventoryFile.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(updatedelistedDetails.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(updatedelistedDetails.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.updatedelistedDetailsSuccess = true;
        })
        builder.addCase(updatedelistedDetails.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(toggleVendorInventorySwitch.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(toggleVendorInventorySwitch.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.toggleVendorInventorySwitchSuccessMessage = action.payload.data.message ?? 'random';
        })
        builder.addCase(toggleVendorInventorySwitch.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
    }
})

export const { clearErrorState, clearUpdateInventorySuccess, clearDownloadSampleInventoryFileSuccess, clearUploadInventoryFileSuccess, ClearUpdatedelistedDetailsSuccess, clear } = getVendorInventoryDetails.actions
export default getVendorInventoryDetails.reducer     